<template>
  <div class="dashboard-widget-template widget-one-to-one-agreements" v-loading="loadingWidgetResult">
    <div v-if="!loadingWidgetResult && !widgetResult.length" class="one-to-one-widget-empty">
      <i class="fas fa-clipboard-check"></i>
      <div>Нет договорённостей</div>
    </div>

    <div v-else class="one-to-one-widget-list">
      <div
        v-for="agreement in widgetResult"
        :key="agreement.id"
        class="one-to-one-agreement-row"
        :class="{'is-done': agreement.is_done, 'is-overdue': isOverdue(agreement)}"
        @click="openMeeting(agreement)"
      >
        <i
          class="one-to-one-agreement-row-icon fas"
          :class="agreement.is_done ? 'fa-check-circle' : 'fa-circle'"
        ></i>

        <div class="one-to-one-agreement-row-body">
          <div class="one-to-one-agreement-row-content">{{ agreement.content }}</div>
          <div class="one-to-one-agreement-row-meta">
            {{ counterpartName(agreement) }}
            <span v-if="agreement.block_name"> · {{ agreement.block_name }}</span>
          </div>
        </div>

        <div class="one-to-one-agreement-row-deadline">{{ new Date(agreement.deadline).toLocaleDateString($companyConfiguration.helpers.getDateLocale()) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {WidgetViewMixin} from "@/components/home/dashboard/widgets/WidgetViewMixin";

export default {
  name: 'OneToOneAgreementsWidgetTemplate',
  mixins: [WidgetViewMixin],
  props: {},
  computed: {
    ...mapGetters({currentUser: 'user'}),
  },
  mounted() {
    this.loadWidgetResult({
      expand: 'block, block.meeting, block.meeting.initiator, block.meeting.participant',
    })
      .then(() => {
        this.widgetResult = this.widgetResult || [];
      });
  },
  data() {
    return {
      widgetResult: [],
    };
  },
  methods: {
    isOverdue(agreement) {
      if (agreement.is_done || !agreement.deadline) return false;
      return (new Date(agreement.deadline)) < (new Date((new Date()).toDateString()));
    },
    counterpartName(agreement) {
      const isInitiator = agreement?.initiator?.id === this?.currentUser?.id;
      const counterpart = isInitiator ? agreement?.block?.meeting?.participant : agreement?.block?.meeting?.initiator;
      return counterpart ? counterpart?.full_name : '—';
    },
    openMeeting(agreement) {
      if( this.editMode ) {
        return;
      }
      if( this.data.openInNewWindow ){
        let route = this.$router.resolve({ name: 'OneToOneMeeting', params: { id: agreement?.block?.meeting_id } });
        window.open(route.href);
      } else {
        this.$router.push({name: 'OneToOneMeeting', params: {id: agreement?.block?.meeting_id}});
      }
    },
  },
}
</script>

<style lang="scss">
.widget-one-to-one-agreements {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 8px;
  box-sizing: border-box;

  .one-to-one-widget-empty {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #9CA3AF;
    gap: 8px;

    i {
      font-size: 24px;
    }
  }

  .one-to-one-widget-list {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .one-to-one-agreement-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 10px;
    border: 1px solid #eceef1;
    border-radius: 6px;
    cursor: pointer;
    transition: border-color .15s ease, box-shadow .15s ease;

    &:hover {
      border-color: #d1d5db;
      box-shadow: 0 2px 8px rgba(17, 24, 39, 0.06);
    }

    &-icon {
      flex: 0 0 auto;
      color: #d1d5db;
      font-size: 14px;
    }

    &.is-done &-icon {
      color: #67c23a;
    }

    &.is-overdue &-icon {
      color: #f56c6c;
    }

    &-body {
      flex: 1;
      min-width: 0;
    }

    &-content {
      font-size: 13px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &.is-done &-content {
      text-decoration: line-through;
      color: #9CA3AF;
    }

    &-meta {
      font-size: 12px;
      color: #6b7280;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &-deadline {
      flex: 0 0 auto;
      font-size: 12px;
      color: #6b7280;
    }

    &.is-overdue &-deadline {
      color: #f56c6c;
      font-weight: 600;
    }
  }
}
</style>
